//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: ''
            })
        }
    },
    data () {
        return {
            form: {
            }
        }
    },
    methods: {
        getData() {
            this.$post(this.getStore('finUrl') + '/verify/bill_detail', this.search, (data) => {
                data.bill_detail.order_list = data.order_list;
                data.bill_detail.fileurl = data.fileurl
                this.form = data.bill_detail;
            });
        },

    },
    mounted () {
        this.getData();
    }
}
